import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AtecoConfiguration } from '../../configuration/ateco/ateco-configuration';
import { ListaAtecoView } from '../../model/lista-ateco-view';

@Injectable({
  providedIn: 'root'
})
export class AtecoService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  })
  constructor(public http: HttpClient) { }

  ricercaAtecoByIdProfilo(id:any): Observable<ListaAtecoView[]> {
    return this.http.get<ListaAtecoView[]>(AtecoConfiguration.ricercaAtecoByIdProfilo + id, { headers: this.headers });
  }

  ricercaAtecoByIdCompetenza(id:any): Observable<ListaAtecoView[]> {
    return this.http.get<ListaAtecoView[]>(AtecoConfiguration.ricercaAtecoByIdCompetenza + id, { headers: this.headers });
  }

  ricercaAteco(data: any, page: number, pageSize: number, searchType:number): Observable<ListaAtecoView[]> {
    return this.http.post<ListaAtecoView[]>(AtecoConfiguration.ricercaAteco + page + "/" + pageSize + "/" + searchType, data, { headers: this.headers });
  }

  salvaAtecoByIdProfilo(data:any,id:any) {
    return this.http.post<any[]>(AtecoConfiguration.salvaAtecoByIdProfilo + id, data, { headers: this.headers });
  }

  salvaAtecoByIdCompetenza(data:any,id:any) {
    return this.http.post<any[]>(AtecoConfiguration.salvaAtecoByIdCompetenza + id, data, { headers: this.headers });
  }

  getCodiciAtecoByIdProposta(id:any): Observable<ListaAtecoView[]> {
    return this.http.get<ListaAtecoView[]>(AtecoConfiguration.getCodiciAtecoByIdProposta + id, { headers: this.headers });
  }

  getCodiciAtecoByIdCompetenza(id:any): Observable<ListaAtecoView[]> {
    return this.http.get<ListaAtecoView[]>(AtecoConfiguration.getCodiciAtecoByIdCompetenza + id, { headers: this.headers });
  }

  getElencoAteco(data: string): Observable<any[]> {
    return this.http.get<any[]>(AtecoConfiguration.getElencoAteco + data, { headers: this.headers });
  }
}
